<template>
  <b-container v-if="event">
    <h4>
      Titel:
    </h4>
    <b-input type="text" v-model="event.name"
             :state="failed ? !!event.name : undefined"
    />
    <b-form-invalid-feedback>
      Bitte geben sie einen Titel ein!
    </b-form-invalid-feedback>
    <br>
    <h4>Beschreibung:</h4>
    <b-input type="text" v-model="event.description" placeholder="Darf leer sein"></b-input>
    <br>
    <h4>Start:</h4>
    <b-form-datepicker
        locale="de"
        start-weekday="1"
        placeholder="Kein Datum ausgewählt"
        v-model="event.start"
        menu-class="w-100"
        calendar-width="100%"
        class="mb-2"
    />
    <b-form-input
        v-model="event.start_time"
        :state="validateTime(event.start_time)"
    />
    <br>
    <h4>Ende:</h4>
    <b-form-datepicker
        locale="de"
        start-weekday="1"
        placeholder="Kein Datum ausgewählt"
        v-model="event.end"
        menu-class="w-100"
        calendar-width="100%"
        class="mb-2"
    />
    <b-form-input
        v-model="event.end_time"
        :state="validateTime(event.end_time)"
    />
    <br>
    <h4>Kategorie</h4>
    <b-form-radio-group
        v-model="event.calendar_id"
        :options="calendars"
        stacked
    />
    <hr class="mt-4 mb-4">
    <b-button variant="outline-success" @click="handleSubmit" block>
      {{ create ? 'Erstellen' : 'Speichern' }}
    </b-button>
    <b-button v-if="!create" variant="outline-danger" @click="confirmEventDelete" block class="mb-5">Löschen</b-button>
  </b-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import helpers from "@/helpers";

export default {
  name: 'EventEdit',
  props: {
    create: Boolean
  },
  data() {
    return {
      failed: false,
      eventId: parseInt(this.$route.params.eventId),
    }
  },
  computed: {
    ...mapGetters([
      'getStoredEventById',
      'getNewEvent',
      'getStoredCalendars',
    ]),
    event() {
      if (this.create) return this.getNewEvent
      return this.getStoredEventById(this.eventId)
    },
    calendars() {
      let parsedCalendars = []
      for (let calendar of this.getStoredCalendars) {
        parsedCalendars.push({
          value: calendar.id,
          text: calendar.name
        })
      }
      return parsedCalendars
    },
  },
  methods: {
    ...mapActions([
      'storeEvent',
      'createEvent',
      'getCalendars',
      'deleteEvent',
    ]),
    handleSubmit() {
      if (!this.event.name || !this.validateTime(this.event.end_time) || !this.validateTime(this.event.start_time)) {
        this.failed = true
        helpers.handleWarningMessage("Die eingegebenen Daten sind ungültig.", "Ungültig!")
        return
      }

      if (this.create) this.createEvent(this.event)
      else this.storeEvent(this.event)
    },
    confirmEventDelete() {
      this.$bvModal.msgBoxConfirm('Wollen sie den Termin wirklich löschen ?', {
        title: 'Löschen',
        okVariant: 'outline-danger',
        okTitle: 'Ja',
        cancelTitle: 'Abbrechen',
        cancelVariant: 'outline-success',
        centered: true
      })
          .then(value => {
            if (value) {
              this.deleteEvent(this.eventId)
            }
          })
    },
    validateTime(time) {
      const regex = /(?:[01]\d|2[0123]):[012345]\d:[012345]\d/gm;
      return time.match(regex) !== null && time.match(regex).length === 1;
    }
  },
  mounted() {
    this.getCalendars
  }
}
</script>

<style>

</style>
